import { api } from "@/lib/api";
import type { Comment } from "@/types";

export async function getCompetitionComments(competitionId: string) {
  const res = await api.get<Comment[]>(`/competitions/${competitionId}/comments`);
  if (res.error) return { data: null, error: res.error };
  return { data: res.data, error: null };
}

export async function createCompetitionComment(
  competitionId: string,
  body: string,
  parentId?: string,
) {
  return api.post(`/competitions/${competitionId}/comments`, { body, parentId: parentId ?? null });
}

export async function toggleReaction(commentId: string, emoji: string) {
  return api.post(`/comments/${commentId}/reactions`, { emoji });
}

export async function getCompetitionMemberUsernames(competitionId: string) {
  const res = await api.get<string[]>(`/competitions/${competitionId}/member-usernames`);
  if (res.error) return { data: null, error: res.error };
  return { data: res.data, error: null };
}
